<template>
  <div class="content-wrapper">
    <div class="flex mb-4 overflow-visible">
      <div class="lg:w-full w-full bg-grid-color h-12 overflow-visible">
        <vs-card class="px-5 py-5 overflow-visible" ref="target">
          <div class="sticky-menu p-0 py-2" :class="{ sticking }">
            <vs-button
              class="mr-3 mb-2 px-12"
              @click="validateUpsell"
              size="large"
              >Save
            </vs-button>
          </div>

          <vs-input
            ref="upsell_title"
            v-model="upsell_title"
            class="mb-5 choice underline w-100 upsell-title"
            :placeholder="`Upsell Title`"
            block
            size="large"
          ></vs-input>

          <vs-input
            ref="upsell_description"
            v-model="upsell_description"
            class="mb-5 choice underline w-100"
            :placeholder="`Upsell Description`"
            block
          ></vs-input>

          <hr />

          <div class="overflow-visible">
            <div class="tab-text overflow-visible">
              <h2>Trigger By</h2>
              <v-select
                ref="triggerBy"
                v-model="triggerBy"
                class="choice"
                :searchable="false"
                :options="triggerOptions"
                placeholder="Trigger On"
              />
              <hr />
              <h2 v-if="triggerBy" class="mt-4">On Page</h2>
              <v-select
                ref="pageOn"
                v-if="triggerBy"
                v-model="pageOn"
                :searchable="false"
                :options="pageOptions"
                placeholder="Page is"
              />

              <hr v-if="triggerBy" />

              <h2>How to show the Upsell</h2>
              <b-form-select
                v-model="action"
                class="choice"
                :clearable="false"
                :searchable="false"
                :options="actionOptions"
                placeholder="Action"
              />

              <hr />
              <div v-if="action == 'show_content_in_page'">
                <h2 class="mt-4 mb-4">Type</h2>
                <b-form-select
                  v-model="offerType"
                  class="choice"
                  :clearable="false"
                  :searchable="false"
                  :options="offerTypeOptions"
                  placeholder="Action type"
                />

                <hr />
                <h2 class="mt-4 mb-4">Intro Text</h2>
                <ArticleEditor
                  v-model="introText"
                  :config="{
                    plugins: ['blockcode'],
                    addbarAdd: ['text', 'card'],
                    css: '/article-editor/css/',
                    format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                    align: {
                      left: 'text-left',
                      center: 'text-center',
                      right: 'text-right',
                      justify: 'text-justify'
                    }
                  }"
                ></ArticleEditor>
                <hr />

                <h2 class="mt-4 mb-4">Show Countdown</h2>
                <div class="d-flex align-items-center">
                  <vs-switch v-model="isShowCountdown" />
                  <div
                    v-if="isShowCountdown"
                    class="d-flex align-items-center ml-3"
                  >
                    <vs-input
                      v-model="countdown"
                      class="mb-0 choice underline w-100"
                      :placeholder="`Countdown`"
                    ></vs-input>
                    <div class="ml-3">Mins</div>
                  </div>
                </div>
                <hr />

                <h2 class="mt-4 mb-4">Button</h2>
                <div class="d-flex ml-3 align-items-center">
                  <h4 class="mb-0" style="width: 155px">Buy Button Text:</h4>
                  <vs-input
                    v-model="buy_button_text"
                    class="mb-0 ml-3"
                    :placeholder="`Buy Button Text`"
                  ></vs-input>
                </div>
                <div class="d-flex mt-2 ml-3 align-items-center">
                  <h4 class="mb-0" style="width: 155px">Skip Button Text:</h4>
                  <vs-input
                    v-model="skip_button_text"
                    class="mb-0 ml-3"
                    :placeholder="`Skip Button Text`"
                  ></vs-input>
                </div>

                <hr />
                <h2 class="mt-4 mb-4">What to upsell?</h2>
                <b-form-select
                  class="mb-2"
                  v-model="what_to_upsell_mode"
                  :options="what_to_upsell_mode_options"
                ></b-form-select>
                <h2
                  v-if="
                    what_to_upsell_mode == 'select_product' ||
                      what_to_upsell_mode == 'both'
                  "
                  class="mt-4"
                >
                  Products to Offer
                </h2>
                <v-select
                  v-if="
                    what_to_upsell_mode == 'select_product' ||
                      what_to_upsell_mode == 'both'
                  "
                  v-model="ticket"
                  class="choice"
                  :searchable="false"
                  :multiple="offerType != 'one-time-offer'"
                  :options="products"
                  placeholder="Products to Offer"
                />

                <hr />
                <h2 class="mt-4 mb-4">
                  How many times to show to each user?(frequency)
                </h2>
                <ul class="demo-alignment mt-3">
                  <li>
                    <vs-radio
                      vs-name="frequency"
                      v-model="frequency_mode"
                      vs-value="only_once"
                      >Only once</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="frequency"
                      v-model="frequency_mode"
                      vs-value="every_time"
                      >Every time</vs-radio
                    >
                  </li>
                  <li>
                    <div class="d-flex align-items-center">
                      <vs-radio
                        vs-name="frequency"
                        v-model="frequency_mode"
                        vs-value="specific"
                        >Specify frequency</vs-radio
                      >
                      <vs-input
                        v-if="frequency_mode == 'specific'"
                        type="number"
                        v-model="frequency"
                        class="mb-0 ml-3"
                        :placeholder="`Specify frequency`"
                      ></vs-input>
                    </div>
                  </li>
                </ul>
              </div>
              <hr />
              <h2 class="mt-4 mb-4">Upsell Period</h2>
              <el-date-picker
                v-validate="'required'"
                name="daterange"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm"
                format="dd-MM-yyyy HH:mm"
                v-model="daterange"
                type="datetimerange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
              ></el-date-picker>

              <hr />
              <h2 class="mt-4 mb-4">Weight</h2>
              <vs-input
                type="number"
                v-model="weight"
                class=""
                :placeholder="`Buy Button Text`"
              ></vs-input>

              <hr />
              <h2 class="mb-4">Conditions</h2>
              <groupcondition
                class="mx-4"
                :forms="forms"
                :groups.sync="conditiongroups"
                :tickets="products"
              />
              <!-- <draggable
                :list="conditions"
                :options="{
                  handle: '.drag-handle',
                  animation: 300,
                }"
                tag="div"
              >
                <div
                  v-for="(condition, index) in conditions"
                  :key="`cond` + index"
                  class="radio-option mb-3"
                >
                  <div class="d-flex align-item-center ml-4">
                    <div>
                      <h4 class="">Field</h4>
                      <v-select
                        class="choice"
                        style="min-width: 200px"
                        v-model="conditionsField[index]"
                        :clearable="false"
                        :options="fieldOptions"
                        placeholder="Field is"
                        @option:selected="
                          () => {
                            if (conditionsField[index]) {
                              conditions[index].field =
                                conditionsField[index].value;
                            }
                          }
                        "
                      />
                    </div>
                    <div
                      v-if="
                        conditions[index].field &&
                        conditions[index].field != 'question'
                      "
                      class="mx-3"
                    >
                      <h4>Operator</h4>
                      <v-select
                        class="choice"
                        style="min-width: 150px"
                        v-model="conditions[index].operator"
                        :clearable="false"
                        :options="operatorOptions"
                        placeholder="Field is"
                      />
                    </div>
                    <div
                      v-if="
                        conditions[index].field &&
                        conditions[index].field != 'question'
                      "
                    >
                      <h4>Value</h4>
                      <vs-input
                        v-model="conditions[index].value"
                        class="w-100"
                        :placeholder="`Value`"
                      ></vs-input>
                    </div>
                  </div>
                  <div
                    v-if="
                      conditions[index].field &&
                      conditions[index].field == 'question'
                    "
                    class="d-flex align-item-center ml-4 pl-5 mt-4"
                  >
                    <div class="">
                      <h4 class="">Form is</h4>
                      {{ forms }}
                      <v-select
                        class="choice"
                        style="min-width: 200px"
                        v-model="conditionsFormIs[index]"
                        :clearable="false"
                        :options="forms"
                        placeholder="Form"
                        :searchable="false"
                        @option:selected="
                          () => {
                            if (conditionsFormIs[index]) {
                              fetchQuestionList(conditionsFormIs[index].value);
                            }
                          }
                        "
                      />
                    </div>
                    <div v-if="showQuestions(index)" class="ml-5">
                      <div>
                        <h4 class="">Question is</h4>
                        {{ question_list[conditionsFormIs[index].value] }}
                        <v-select
                          class="choice"
                          style="min-width: 500px"
                          v-model="conditionsQuestionIs[index]"
                          :clearable="false"
                          :options="
                            question_list[conditionsFormIs[index].value]
                          "
                          placeholder="Form"
                          @option:selected="
                            () => {
                              if (conditionsQuestionIs[index]) {
                                conditions[index].operator = '=';
                                conditions[index].value =
                                  conditionsQuestionIs[index].value;
                                if (!conditions[index].conditions) {
                                  conditions[index].conditions = [
                                    {
                                      field: 'answer',
                                      operator: '',
                                      value: '',
                                    },
                                  ];
                                }
                                if (!conditionsSubconditions[index]) {
                                  conditionsSubconditions[index] = [
                                    { operator: {}, value: {} },
                                  ];
                                }
                                conditionsQuestionIs = jsonparse(
                                  jsonstrigfy(conditionsQuestionIs)
                                );

                                // fetchQuestionList(
                                //   conditionsQuestionIs[index].value
                                // );
                              }
                            }
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      conditions[index].field &&
                      conditions[index].field == 'question' &&
                      conditionsQuestionIs[index] &&
                      conditions[index].conditions.length
                    "
                    class="d-flex align-item-center ml-4 pl-5 mt-4"
                  >
                    <div class="mr-5">
                      <h4>Answer</h4>
                      <v-select
                        class="choice"
                        style="min-width: 200px"
                        v-model="conditionsSubconditions[index].operator"
                        :clearable="false"
                        :options="operatorOptions"
                        placeholder="Operator"
                        @option:selected="
                          () => {
                            conditions[index].conditions[0].operator =
                              conditionsSubconditions[index].operator.value;
                            conditions[index].conditions[0].value = '';
                            conditions = jsonparse(jsonstrigfy(conditions));
                          }
                        "
                      />
                    </div>
                    <div>
                      <h4>Value</h4>
                      <v-select
                        v-if="
                          question_list_by_uuid[
                            conditionsFormIs[index].value
                          ] &&
                          question_list_by_uuid[conditionsFormIs[index].value][
                            conditions[index].value
                          ] &&
                          question_list_by_uuid[conditionsFormIs[index].value][
                            conditions[index].value
                          ].options
                        "
                        class="choice"
                        style="min-width: 200px"
                        v-model="conditionsSubconditions[index].value"
                        :clearable="false"
                        :options="
                          question_list_by_uuid[conditionsFormIs[index].value][
                            conditions[index].value
                          ].options
                        "
                        :multiple="
                          ['in', 'not in'].includes(
                            conditions[index].conditions[0].operator
                          )
                        "
                        @option:selected="
                          () => {
                            conditions[index].conditions[0].value =
                              conditionsSubconditions[index].value.value ||
                              conditionsSubconditions[index].value.map(
                                (item) => item.value
                              );
                            conditions = jsonparse(jsonstrigfy(conditions));
                          }
                        "
                        placeholder="Value is"
                      />
                    </div>
                  </div>
                  <hr class="mx-5" />
                </div>
              </draggable>
              <vs-button
                class="add-option-button ml-0 px-2"
                type="flat"
                @click="addCondition()"
                >Add Condition
              </vs-button> -->
              <!-- <QuestionComp :list="questions"></QuestionComp> -->
            </div>

            <hr />

            <!-- <vs-button target="_blank" color="primary" @click="addQuestion()"
              >Add Question
            </vs-button>

            <div class="vx-row pt-2 mt-0">
              <div class="vx-col col-auto ml-auto">
                <vs-button class="mr-3 mb-2" @click="validateUpsell"
                  >Save
                </vs-button>
              </div>
            </div> -->
          </div>
        </vs-card>
      </div>
    </div>
    <vs-popup title="Delete Question?" :active.sync="confirmDeleteDialog">
      <div style="min-height: 100px" class="m-5">
        Are you sure you want to delete the Question?
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="removeQuestion(deleteIndex)"
          >Delete</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="confirmDeleteDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Upsell is not valid" :active.sync="errorDialog">
      <div class="m-1">
        {{ errorText }}
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class=""
          @click="errorDialog = false"
          >OK</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup title="Upsell update" :active.sync="successDialog">
      <div class="m-1">
        {{ successText }}
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class=""
          @click="
            () => {
              successDialog = false;
              $router.replace('/upsells');
            }
          "
          >OK</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import { Validator } from "vee-validate";
import Service from "@/services";
import { mapState } from "vuex";
// import Option from "./Option.vue";
// import QuestionComp from "@/components/soldoutt/QuestionComp.vue";
// import QuestionDialog from "@/components/soldoutt/QuestionDialog.vue";
import groupcondition from "@/components/soldoutt/upsell/groupcondition.vue";
// import EllipsisMenu from "@/components/EllipsisMenu.vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
const short = require("short-uuid");
const translator = short();
import moment from "moment";

import ArticleEditor from "@/components/ArticleEditor.vue";

export default {
  components: {
    // Option,
    // QuestionComp,
    // QuestionDialog,
    // Question,
    draggable,
    groupcondition,
    ArticleEditor,
    // EllipsisMenu,
    vSelect
  },
  props: ["upsell_id"],
  data() {
    return {
      conditiongroups: {
        logic_between_groups: "AND",
        groups: []
      },
      upsell_title: "",
      upsell_description: "",
      triggerBy: "",
      introText: "",
      isShowCountdown: false,
      countdown: 15,
      frequency_mode: "only_once",
      frequency: 3,
      buy_button_text: "I’m Interested",
      skip_button_text: "Not now",
      what_to_upsell_mode: "select_product",
      what_to_upsell_mode_options: [
        {
          text: "Select product manually",
          value: "select_product"
        },
        {
          text: "Show Products based on conditions",
          value: "product_base_on_condition"
        },
        {
          text: "Both",
          value: "both"
        }
      ],
      conditions: [],
      conditionsField: [],
      conditionsFormIs: [],
      conditionsQuestionIs: [],
      conditionsSubconditions: [],
      forms: [],
      question_list: {},
      triggerOptions: [
        {
          label: "Visit page",
          value: "visit-page"
        },
        {
          label: "Ticket added",
          value: "visit-page"
        },
        {
          label: "Click Submit",
          value: "click-submit"
        },
        {
          label: "Exit",
          value: "exit"
        },
        {
          label: "Time on page",
          value: "time-on-page"
        }
      ],
      fieldOptions: [
        {
          label: "Question",
          value: "question"
        },
        {
          label: "Selected Ticket",
          value: "selected_ticket"
        },
        {
          label: "Token",
          value: "token"
        }
      ],
      operatorOptions: [
        {
          label: "is",
          value: "="
        },
        {
          label: "is not",
          value: "!="
        },
        {
          label: "is in",
          value: "in"
        },
        {
          label: "is not in",
          value: "not in"
        },
        {
          label: "greater than",
          value: ">"
        },
        {
          label: "less than",
          value: "<"
        },
        {
          label: "greater than or equal to",
          value: ">="
        },
        {
          label: "less than or equal to",
          value: "<="
        }
      ],
      pageOn: "",
      pageOptions: [
        {
          label: "Register",
          value: "register"
        },
        {
          label: "Thank you",
          value: "thankyou"
        },
        {
          label: "Attendee Info",
          value: "attendee_info"
        }
      ],
      action: "",
      actionOptions: [
        {
          text: "Show Content In Page",
          value: "show_content_in_page"
        }
      ],
      offerType: "one-time-offer",
      offerTypeOptions: [
        {
          text: "One time offer",
          value: "one-time-offer"
        },
        {
          text: "Add-Ons List",
          value: "add-ons-list"
        }
      ],
      ticket: "",
      products: [],
      ticketOptions: [],
      deleteIndex: -1,
      confirmDeleteDialog: false,
      errorDialog: false,
      errorText: "",
      successDialog: false,
      successText: "",
      FilterDialog: false,
      FilterIndex: -1,
      sticking: false,
      weight: 1,
      daterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ]
    };
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    question_list_by_uuid() {
      const new_map = {};
      for (const [key, value] of Object.entries(this.question_list)) {
        new_map[key] = {};

        for (const [_, value2] of Object.entries(value)) {
          new_map[key][value2.value] = value2;
        }
      }

      return new_map;
    },
    showticketOptions() {
      return this.products
        .filter(
          item => !this.hideTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    showattendeeRoleOptions() {
      const hiderolelist = this.hideRoleList;
      return this.attendee_roles
        .filter(item => !hiderolelist.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    },
    hideticketOptions() {
      return this.products
        .filter(
          item => !this.showTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    hideattendeeRoleOptions() {
      return this.attendee_roles
        .filter(item => !this.showRoleList.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    }
  },
  created() {
    this.$vs.loading();
    setTimeout(() => {
      this.fetchData();
    }, 1000);
  },
  mounted() {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticking = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer.observe(this.$refs.target);
    } catch (_) {
      console.log();
    }
  },
  methods: {
    consolelog: console.log,
    jsonstrigfy: JSON.stringify,
    jsonparse: JSON.parse,
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    showDeleteDialog(index) {
      this.deleteIndex = index;
      this.confirmDeleteDialog = true;
    },
    showQuestions(index) {
      return (
        this.conditionsFormIs[index] &&
        this.question_list[this.conditionsFormIs[index].value]
      );
    },
    fetchData() {
      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100,
        upsell_id: this.upsell_id
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Event.getProducts(this.e || this.$route.query.e).then(
        products => {
          this.products = products.data.items || [];

          // this.remain_quantity = parseInt(products.data.remain_free);
          this.products = this.products
            .sort(this.compareValues("weight", "desc"))
            .map(item => {
              return {
                label: item.pro_name,
                value: item.product_id
              };
            });
        }
      );

      Service.Event.get(this.e || this.$route.query.e)
        .then(event => {
          this.event_id = event.data.event.event_id;
          const ticket_role_object = event.data.event.ticket_role
            ? JSON.parse(event.data.event.ticket_role)
            : {};
          const ticket_roles = Object.keys(ticket_role_object);
          this.attendee_roles = [];
          for (
            let ticket_roles_index = 0;
            ticket_roles_index < ticket_roles.length;
            ticket_roles_index++
          ) {
            this.attendee_roles.push(
              ticket_role_object[ticket_roles[ticket_roles_index]]
            );
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });

      this.fetchFormList();
    },
    fetchFormList() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      // params =
      //   params +
      //   "&" +
      //   Object.keys(ctx)
      //     .map(key => key + "=" + ctx[key])
      //     .join("&");

      Service.Question.forms(params)
        .then(res => {
          const forms = res.data.rows;
          if (forms && forms.map) {
            this.forms = forms.map(item => {
              return {
                label: item.form_title,
                value: item.form_uuid
              };
            });
          }
        })
        .catch(error => {
          console.log(error);
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          //return [];
        });
    },
    fetchQuestionList(form_id) {
      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100,
        form_id: form_id
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Question.getQuestions(params)
        .then(res => {
          this.question_list[form_id] = res.data.rows.map(item => {
            // let max = null;
            // if (item.validations.length > 0) {
            //   item.validations.map((valid) => {
            //     if (valid.rule == "max") {
            //       max = valid.value;
            //     }
            //   });
            // }
            const mapped_item = {
              label: item.question_title,
              value: item.question_uuid,
              question_type: item.question_type
            };
            if (
              item.question_type == "checkbox" ||
              item.question_type == "radio" ||
              item.question_type == "select"
            ) {
              mapped_item.options = item.options_json.map
                ? item.options_json.map(item => {
                    return {
                      value: item.value,
                      label: item.text
                    };
                  })
                : [];
            }
            return mapped_item;
          });
          this.question_list = JSON.parse(JSON.stringify(this.question_list));
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    addCondition(index = -1) {
      if (index == -1) {
        this.conditions.push({
          field: "",
          operator: "",
          value: ""
        });
      } else {
        this.conditions.splice(index + 1, 0, {
          field: "",
          operator: "",
          value: ""
        });
      }
    },
    descriptionEnabled(index, enable) {
      this.questions[index].description_enabled = enable;
      this.refreshQuestion();
    },
    conditionEnabled(index, enable) {
      this.questions[index].condition_enabled = enable;
      this.refreshQuestion();
    },
    openQuestionDialog() {
      this.questionDialog = true;
    },
    onQuestionClose() {
      this.questionDialog = false;
    },
    onQuestionSubmit() {
      this.questionDialog = false;
      this.fetchData();
    },
    removeQuestion(index) {
      // remove the question at the specified index
      this.confirmDeleteDialog = false;
      this.questions.splice(index, 1);
    },
    submitUpsell() {
      let frequency = 1;
      if (this.frequency_mode == "only_once") {
        frequency = 1;
      }
      if (this.frequency_mode == "every_time") {
        frequency = null;
      } else {
        frequency = this.frequency;
      }
      const upsell_content = {
        type: this.action,
        content: {
          format: this.offerType,
          intro_text: this.introText,
          show_fallback_items:
            this.what_to_upsell_mode == "select_product" ? 0 : 1,
          product_ids: Array.isArray(this.ticket)
            ? this.ticket.map(t => t.value)
            : [this.ticket.value],
          frequency: frequency,
          countdown: this.isShowCountdown ? this.countdown : null,
          buy_button_text: this.buy_button_text,
          skip_button_text: this.skip_button_text
        }
      };
      const upsell = {
        event_id: this.event_id,
        title: this.upsell_title,
        description: this.upsell_title,
        trigger_by: this.triggerBy ? this.triggerBy.value : "",
        trigger_value: this.pageOn ? this.pageOn.value : "",
        conditions: this.conditiongroups,
        actions: upsell_content,
        datetime_start: this.daterange[0],
        datetime_end: this.daterange[1],
        publish_status: 1,
        listing_status: 1,
        weight: this.weight
      };
      this.$vs.loading();
      Service.Upsell.create(upsell)
        .then(res => {
          if (res.success) {
            // const data = res.data;
            // const dataUpsell = data.upsell;

            // this.$vs.notify({
            //   title: "Success",
            //   text: "Update complete.",
            //   color: "success",
            // });
            this.successText = "Create Upsell complete.";
            this.successDialog = true;
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.successText = "ERROR : " + err.error;
          this.successDialog = true;
          this.$vs.loading.close();
        });
    },
    validateUpsell() {
      let isValid = true;

      if (!this.upsell_title) {
        isValid = false;
        this.errorText = `Please add a Upsell Title.`;
        this.$refs["upsell_title"].focusInput();
      } else if (!this.upsell_description) {
        isValid = false;
        this.errorText = `Please add a Upsell Description.`;
        this.$refs["upsell_description"].focusInput();
      } else if (!this.triggerBy) {
        isValid = false;
        this.errorText = `Please when to trigger.`;
        this.$refs["triggerBy"].select();
      } else if (!this.pageOn) {
        isValid = false;
        this.errorText = `Please trigger on page.`;
        this.$refs["pageOn"].select();
      } else if (
        !this.conditiongroups ||
        !this.conditiongroups.groups ||
        !this.conditiongroups.groups.length
      ) {
        isValid = false;
        this.errorText = `Please add a condition.`;
      } else {
        for (let i = 0; i < this.conditiongroups.groups.length; i++) {
          if (!this.conditiongroups.groups[i].sub_groups.length) {
            isValid = false;
            this.errorText = `Please add a condition.`;
          }
        }
      }
      if (!isValid) {
        this.errorDialog = true;
      } else {
        this.submitUpsell();
      }
    }
  }
};
</script>
<style scoped>
.remove-question-button {
  cursor: pointer;
  color: red;
  margin-left: 10px;
  /* position: absolute;
  right: 5px;
  top: 0; */
  font-size: 30px;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 100px;
}

.tooltip-menu div {
  cursor: pointer;
  padding: 5px;
}

/* Style the 3 dots icon (you may need to adjust this based on your icon library) */
i.fas.fa-ellipsis-v {
  cursor: pointer;
}
.ghost {
  /* background: red; */
  background: #f8f8f8;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transupsell: translateX(30px);
}
.filter-table * {
  font-size: 1.3rem !important;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 62px;
  z-index: 999;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}
</style>

<style>
.con-vs-tabs,
.vs-card--content {
  overflow: visible !important;
}

.filter-table .vs__selected {
  font-size: 1.1rem !important;
}
.filter-popup .vs-popup {
  height: 360px !important;
}

.filter-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}
.vs-input--placeholder.large {
  font-size: 1.2rem;
}

div.upsell-title input.vs-input--input {
  font-size: 1.8rem !important;
}

div.upsell-title .vs-input--placeholder {
  font-size: 1.8rem;
}
</style>
